import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Container,
  Typography,
  DialogActions,
  Button,
  CircularProgress,
  Box,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import ImageThumbnail from '../../widgets/ImageThumbnail';

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    display: 'flex',
  },
  contentThumb: {
    marginRight: theme.spacing(1),
  },
  errorButton: {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

const CRUDDeleteDialog = (props) => {
  const {
    open,
    onDelete,
    onClose,
    name,
    isLoading,
    title,
    subtitle,
    thumb,
  } = props;
  const classes = useStyles();

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      disableBackdropClick={isLoading}
      open={open}
      onClose={onClose}
    >
      <DialogTitle>
        <FormattedMessage id="seed.CRUDDeleteDialog.title" values={{ name }} />
      </DialogTitle>
      <DialogContent>
        <Container className={classes.contentContainer}>
          {
            thumb ? (
              <ImageThumbnail
                className={classes.deleteDialogContentThumb}
                src={thumb}
                alt={name}
              />
            ) : <span />
          }
          <Container>
            <Typography color="textPrimary">
              {title}
            </Typography>
            <Typography variant="caption">
              {subtitle}
            </Typography>
          </Container>
        </Container>
      </DialogContent>
      <DialogActions>
        <Box>
          {
            isLoading ? <CircularProgress size={20} /> : <span />
          }
        </Box>
        <Button
          onClick={onClose}
          disabled={isLoading}
          variant="outlined"
        >
          <FormattedMessage id="seed.button.cancel" />
        </Button>
        <Button
          onClick={onDelete}
          color="primary"
          variant="contained"
          disabled={isLoading}
          className={classes.errorButton}
        >
          <FormattedMessage id="seed.button.delete" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CRUDDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,

  name: PropTypes.node,
  isLoading: PropTypes.bool,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  thumb: PropTypes.string,
};

CRUDDeleteDialog.defaultProps = {
  name: '',
  isLoading: false,
  title: '',
  subtitle: '',
  thumb: undefined,
};

export default CRUDDeleteDialog;
